import {ofType} from 'redux-observable';
import {filter, mergeMap, catchError} from 'rxjs/operators';
import {empty} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import ENV from 'web-app/config/environment';
import * as SessionSelectors from 'web-app/react/session/selectors';
import {getWhitelabelPushAppId} from 'web-app/shared/white-labeling-helpers';
import {PushNotificationAppVariant} from 'web-app/services/push-notifications';

import bannerWarningEpics from './banner-warnings/epics';
import notificationCenterEpics from './notification-center/epics';
import notificationCountsEpics from './notification-counts/epics';
import * as Actions from './actions';
import * as Api from './api';

const registerDeviceToken = (action$, state$) =>
    action$.pipe(
        ofType(Actions.didReceiveDeviceToken.type),
        filter(({payload}) => {
            return (
                SessionSelectors.isLoggedIn(state$.value) &&
                payload.deviceToken &&
                !SessionSelectors.isImpersonated(state$.value)
            );
        }),
        mergeMap(({payload}) => {
            return Api.updateDeviceToken(
                payload.deviceToken,
                ENV.APP.platform,
                getWhitelabelPushAppId(),
                PushNotificationAppVariant.capacitor,
            ).pipe(
                catchError(() => {
                    return empty();
                }),
            );
        }),
    );

export default combineEpics(registerDeviceToken, bannerWarningEpics, notificationCenterEpics, notificationCountsEpics);
